"use client";

import { FeaturesSectionProps } from "@/Templates/SectionsProps";
import { FC } from "react";
import GeneratedFeaturesSection from "../Components/GeneratedFeaturesSection";

const Features: FC<FeaturesSectionProps> = (props) => {
  return <GeneratedFeaturesSection {...props} />;
};

export default Features;
